import Audioplayer from './Audioplayer'; 

export default function AudioList() {
    return (
        <div id="audio" className="audio-list-container">
            <h1>Audio</h1>
            <Audioplayer />
        </div>
    );
}
    